<app-chip-autocomplete
    *ngIf="Options$ | async as options; else loading"
    [formControl]="FormControl"
    [MapFn]="MapFn"
    [Options]="options"
    [OptionTemplate]="optionsTemplate"

    Placeholder="Branche"
    [Tooltip]="ToolTip$ | async"
    (UnknownOptionSubmitted)="Add($event)"
    [initialPatchDefaultValue]="true"
></app-chip-autocomplete>

<ng-template #loading>
    <app-loading [Size]="24"></app-loading>
</ng-template>

<ng-template #optionsTemplate let-Option>
    <div>
        {{ MapFn(Option) }}

        <button mat-icon-button *ngIf="CanDelete$ | async" (click)="Delete(Option, $event)">
            <fa-icon icon="trash"></fa-icon>
        </button>
    </div>
</ng-template>
